import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import * as LegalResponsibleActions from '@redux/onboarding/legal-responsible-step/legal-responsible-step-action'
import * as OnboardingSelector from 'selectors/onboarding/onboarding-selector'

import TemplateStep from '@components/layout/template-step'
import InputText from '@components/input/input-text/input-text'
import InputCPF from '@components/input/input-cpf/input-cpf'
import InputCellPhone from '@components/input/input-cellphone/input-cellphone'
import InputEmail from '@components/input/input-email/input-email'

const LegalResponsibleStep = () => {
  const dispatch = useDispatch()
  const legalResponsible = useSelector(OnboardingSelector.legalResponsible)

  const handleChange = ({ name, value }) => {
    dispatch(LegalResponsibleActions.setLegalResponsibleField(name, value))
  }

  return (
    <TemplateStep>
      <div className="row">
        <div className="col-12 col-sm-6">
          <InputText
            name="fullName"
            value={legalResponsible.fullName}
            onChange={handleChange}
            fixedLabel
            label="Nome completo do responsável"
            required
          />
        </div>
        <div className="col-12 col-sm-6">
          <InputCPF name="cpf" value={legalResponsible.cpf} onChange={handleChange} fixedLabel label="CPF" required />
        </div>

        <div className="col-12 col-sm-6">
          <InputCellPhone name="cellPhone" value={legalResponsible.cellPhone} onChange={handleChange} fixedLabel label="Celular" required />
        </div>
        <div className="col-12 col-sm-6">
          <InputEmail name="email" value={legalResponsible.email} onChange={handleChange} fixedLabel label="Email" required />
        </div>
      </div>
    </TemplateStep>
  )
}

LegalResponsibleStep.propTypes = {}
LegalResponsibleStep.displayName = 'LegalResponsibleStep_Page'

export default LegalResponsibleStep
